import React from 'react';
import clsx from 'clsx';
import './index.css';
import { toast } from '../../utils/toast';

interface Item {
  key: string;
  label: string;
  disabled?: boolean;
  disabledText?: string;
}
interface IProps {
  items: Item[];
  onChange: (activeKey: string) => any;
  activeKey: string;
  loading?: boolean;
  switchStyle?: Record<string, any>;
}

export default class UserGetModeTabs extends React.Component<IProps, any> {
  onChangeTabs = (item: Item) => {
    const { disabled = false, disabledText = '', key } = item;
    if (disabled) {
      if (disabledText) {
        toast(disabledText, 1);
      }
      return;
    }
    const { onChange, loading = false } = this.props;
    if (loading) {
      return;
    }
    if (onChange) {
      const { activeKey } = this.props;
      if (activeKey !== key) {
        onChange(key);
      }
    }
  };
  render() {
    const { items = [], activeKey, switchStyle } = this.props;
    if (items.length === 0 || !activeKey) return null;
    return (
      <view className="container">
        <view className="user-get-mode-switch" style={{ ...switchStyle }}>
          {items.map((item) => (
            <view
              key={item.key}
              onClick={() => this.onChangeTabs(item)}
              className={clsx('status-btn', { 'ios-shadow': item.key === activeKey && Mach.env.isIOS })}
            >
              {item.key === activeKey ? (
                <view className="active">
                  <text className="btn-text btn-text-active" content={item.label} />
                </view>
              ) : (
                <text className={clsx(item.disabled ? 'btn-text-disabled' : 'btn-text')} content={item.label} />
              )}
            </view>
          ))}
        </view>
      </view>
    );
  }
}
